'use client';

import type { PropsWithChildren } from 'react';
import type { CacheSizes } from '@apollo/client/utilities';
import { ApolloProvider } from '@frameio/graphql-client/apollo/initApolloClient';
import { HostNameProvider } from '@frameio/integrations/shared/components/HostNameProvider';
import {
  SharedAuthContextProvider,
  UxpHostInfoProvider,
} from '@frameio/integrations/shared/contexts';
import { WebAppStyleProvider } from '@frameio/next-shared/style/WebAppStyleProvider';
import { AppStateContextProvider } from '@frameio/shared/contexts/AppStateContext';
import { NavigationHistoryProvider } from '@frameio/shared/integrations/contexts/NavigationHistoryContext';
import { LocaleProvider } from './LocaleProvider';
import { ThemeProvider } from './ThemeProvider';

const APOLLO_CLIENT_CACHE_SIZE: Partial<CacheSizes> = {
  parser: 1_000,
  'fragmentRegistry.lookup': 1_000,
};

export const MainAppClientProviders = (props: PropsWithChildren) => {
  return (
    <ApolloProvider
      initialCacheSize={APOLLO_CLIENT_CACHE_SIZE}
      isUXPIntegration={true}
    >
      <UxpHostInfoProvider>
        <HostNameProvider>
          <LocaleProvider>
            <SharedAuthContextProvider>
              <AppStateContextProvider>
                <ThemeProvider>
                  <WebAppStyleProvider>
                    <NavigationHistoryProvider>
                      {props.children}
                    </NavigationHistoryProvider>
                  </WebAppStyleProvider>
                </ThemeProvider>
              </AppStateContextProvider>
            </SharedAuthContextProvider>
          </LocaleProvider>
        </HostNameProvider>
      </UxpHostInfoProvider>
    </ApolloProvider>
  );
};
